var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138080",
    "data-name": "Rectangle 138080",
    width: 22.182,
    height: 25.582,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50040",
    "data-name": "Group 50040",
    transform: "translate(-664 -1118)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(664 1118)",
    fill: "#44546f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49992",
    "data-name": "Group 49992",
    transform: "translate(676.909 1129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48713",
    "data-name": "Group 48713",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 5.33,
    cy: 5.33,
    r: 5.33,
    transform: "translate(5.762 1.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93236",
    "data-name": "Path 93236",
    d: "M18.843,37.593H5.209a3.2,3.2,0,0,1-2.52-5.179A11.641,11.641,0,0,1,12.026,28a11.641,11.641,0,0,1,9.337,4.414A3.2,3.2,0,0,1,18.843,37.593Z",
    transform: "translate(-0.934 -13.077)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueUsers);
export default __webpack_public_path__ + "static/media/blue-users.296a145e829eccbcf3735490a5c7da3f.svg";
export { ForwardRef as ReactComponent };